
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landscaping",
      function () {
        return require("private-next-pages/landscaping.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landscaping"])
      });
    }
  